/**
 * Evita bloquear Guardar con `!isValid` cuando mode es onTouched.
 * Usar junto con hasRequiredValues + trigger() post-reset.
 */
export function isFormSaveDisabled(params: {
  canSave: boolean;
  hasRequiredValues: boolean;
  hasRequiredFieldErrors: boolean;
}): boolean {
  return (
    !params.canSave ||
    !params.hasRequiredValues ||
    params.hasRequiredFieldErrors
  );
}
